module.exports = __webpack_public_path__ + "img/Images reseaux sociaux gif 2.d5c73d19.png";